import React, { forwardRef, useContext } from 'react';
import {
  arrayOf,
  bool,
  func,
  number,
  shape,
  string
} from 'prop-types';
import { AddTo } from '@thd-olt-component-react/add-to';
import { Add } from '@one-thd/sui-icons';
import { Button } from '@one-thd/sui-atomic-components';
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import { ProductListContext } from '../ProductListContext';

export const AddToMobile = forwardRef(({
  addToProducts,
  handleAddToClick,
  needToLoadProducts,
  noSelectedItems
}, ref) => {

  const { productsDisplayed } = useContext(ProductListContext);
  const { isB2BCustomer = false } = useThdCustomer();

  if (!isB2BCustomer) {
    return (
      <AddTo
        addToType="List"
        products={addToProducts}
        CustomAddToActionElement={({ onClick }) => (
          <Button
            aria-label="Add To List"
            disabled={noSelectedItems}
            onClick={onClick}
            variant="ghost"
          >
            Add to List
          </Button>
        )}
      />
    );
  }

  return (
    <div ref={ref}>{
      (needToLoadProducts)
        ? (
          <Button
            aria-label="Add To"
            startIcon={Add}
            onClick={(onClick) => handleAddToClick(onClick, '...')}
            variant="tertiary"
          >
            Add To
          </Button>
        )
        : (
          <AddTo
            addToFallbackType={null}
            addToType={null}
            loadedProductsData={productsDisplayed}
            showSelectionScreen
            products={addToProducts}
          />
        )
    }
    </div>
  );
});

AddToMobile.propTypes = {
  addToProducts: arrayOf(shape(
    {
      itemId: string.isRequired,
      price: string,
      productData: shape({
        info: shape({}),
        identifiers: shape({}),
        pricing: shape({})
      }),
      quantity: number,
      sku: shape({
        storeSkuNumber: string,
        omsThdSku: string,
        specialOrderSku: string
      })
    }
  )).isRequired,
  handleAddToClick: func.isRequired,
  needToLoadProducts: bool.isRequired,
  noSelectedItems: bool.isRequired
};